export const UserPermissions = ["U-U", "U-I"];
export const RolePermissions = ["R-C", "R-R", "R-U", "R-D"];
export const QuickBooksPermissions = ["I-QBOC"];
export const BankingReconciliationPermissions = ["BR-T-U", "BR-C-U", "BR-G-U"];
